<style>
    .my-drop-zone { border: dotted 3px lightgray; }
    .nv-file-over { border: dotted 3px red; } /* Default class applied to drop zones on over */
    .another-file-over-class { border: dotted 3px green; }

    html, body { height: 100%; }
</style>

<c-card *transloco="let t">
    <c-card-body>

<div class="container">
    <c-row>
      <c-col md="8">
          <h1>{{ t('Import Workers')}}</h1>
      </c-col>
      <c-col  md="4" class="text-end">
        <div class="btn-group mb-2 " role="group">
          <button color="light" cButton routerLink="/mgmt/workers/workers">
            <svg cIcon class="me-2" name="cil-chevron-left"></svg>
            {{ t('Return to Workers') }}
          </button>
          <button type="button" class="btn btn-light" (click)="reset()" *ngIf="step > 1"><i class="fa-solid fa-angles-left"></i> {{ t("Upload another File")}}</button>
          <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352926225553-Uploading-Workers" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
        </div>
        </c-col>
    </c-row>

    <div class="row"  *ngIf="step == 1">

        <p>
          {{ t('You can import workers to OK Alone by using an Excel file.') }} <br />
          {{ t('Please use our') }}
          <a *ngIf="okService.settings.id != 2296" href="/assets/files/Workers.xlsx" target="_new">Workers.xlsx</a>
          <a *ngIf="okService.settings.id == 2296" href="/assets/files/CMS-Workers.xlsx" target="_new">CMS-Workers.xlsx</a>
          {{ t('file as a template, or re-import a file exported from OK Alone. Columns are matched by header name.') }}
          </p>

        <div class="col-md-4">

            <h3>{{ t('Select files') }}</h3>

            <div ng2FileDrop
                 [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                 (fileOver)="fileOverBase($event)"
                 [uploader]="uploader"
                 class="well my-drop-zone"
                 style="width:100%;height:200px;">
                {{ t('Drop your worker upload file here or select it using the button below') }}
            </div>
            <input type="file" ng2FileSelect [uploader]="uploader" />
        </div>

        <div class="col-md-8" style="margin-bottom: 40px">

            <h3>{{ t('Upload queue') }}</h3>
            <p>{{ t('Queue length') }}: {{ uploader?.queue?.length }}</p>

            <table class="table">
                <thead>
                <tr>
                    <th width="50%">{{ t('Name') }}</th>
                    <th>{{ t('Size') }}</th>
                    <th>{{ t('Progress') }}</th>
                    <th>{{ t('Status') }}</th>
                    <th>{{ t('Actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of uploader.queue">
                    <td><strong>{{ item?.file?.name }}</strong></td>
                    <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                    <td *ngIf="uploader.options.isHTML5">
                        <div class="progress" style="margin-bottom: 0;">
                            <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                        </div>
                    </td>
                    <td class="text-center">
                        <span *ngIf="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span>
                        <span *ngIf="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span>
                        <span *ngIf="item.isError"><i class="glyphicon glyphicon-remove"></i></span>
                    </td>
                    <td nowrap>
                        <button type="button" class="btn btn-success btn-xs"
                                (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                            <span class="glyphicon glyphicon-upload"></span> {{ t('Upload') }}
                        </button>
                        <button type="button" class="btn btn-warning btn-xs"
                                (click)="item.cancel()" [disabled]="!item.isUploading">
                            <span class="glyphicon glyphicon-ban-circle"></span> {{ t('Cancel') }}
                        </button>
                        <button type="button" class="btn btn-danger btn-xs"
                                (click)="item.remove()">
                            <span class="glyphicon glyphicon-trash"></span> {{ t('Remove') }}
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <div>
                <div>
                    {{ t('Queue progress') }}:
                    <div class="progress" style="">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
                    </div>
                </div>
                <div class="alert alert-danger" role="alert"  *ngIf="file_error">
                  {{file_error}}
                </div>
            </div>

        </div>

    </div>

    <br><br>

    <div class="row" *ngIf="step == 2">
        <div class="col-md-12">

            <p>{{ t('We have processed the worker upload file. Please check the following worker data. Only workers with no errors will be imported or updated.') }}</p>


            <div class="alert alert-danger" role="alert"  *ngIf="upload_errors">
              <b>{{ t('Upload Issue') }}</b> {{ t('We have detected some issues with your upload file. Please check them in the table below, fix them in the file and resubmit the file.') }}
            </div>
            <div class="alert alert-danger" role="alert"  *ngIf="file_error">
              <b>{{ t('Upload Issue') }}</b> {{file_error}}
            </div>
            <div class="alert alert-danger" role="alert"  *ngIf="!extra_field_valid">
              <b>{{ t('Upload Issue') }}</b> {{ t('Please choose the fields in the drop down for all the extra fields in your upload file.') }}
            </div>


            <c-row>
                <c-col class="text-center">
                  <button type="button" class="btn btn-primary" (click)="uploadWorkers()"  *ngIf="!upload_errors && !file_error"><i class="fa-solid fa-file-import"></i> {{ t('Import these Workers') }}</button>
                  <button type="button" class="btn btn-outline-primary" (click)="reset()"  *ngIf="upload_errors || file_error"><i class="fa-solid fa-angles-left"></i> {{ t('Upload Another File') }}</button> <br/><br/>
                </c-col>
            </c-row>


            <c-row>
                <c-col>

                  <table
                  [hover]="true"
                  [responsive]="true"
                  [striped]="true"
                  align="middle"
                  cTable
                  class="mb-0 border"
                  >
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ t('Worker') }}</th>
                        <th scope="col">{{ t('Email') }}</th>
                        <th scope="col">{{ t('Phone') }}</th>
                        <th scope="col">{{ t('Group') }}</th>
                        <th scope="col" *ngIf="workers[0].monitor_names">{{ t('Monitors') }}</th>
                        <td *ngIf="workers[0].extra_field_1">
                          <ng-select [(ngModel)]="extra_fields[0]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="workers[0].extra_field_2">
                          <ng-select [(ngModel)]="extra_fields[1]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="workers[0].extra_field_3">
                          <ng-select [(ngModel)]="extra_fields[2]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="workers[0].extra_field_4">
                          <ng-select [(ngModel)]="extra_fields[3]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <td *ngIf="workers[0].extra_field_5">
                          <ng-select [(ngModel)]="extra_fields[4]">
                            <ng-option *ngFor="let options of extra_field_options" [value]="options.field">{{options.name}}</ng-option>
                         </ng-select>
                        </td>
                        <th scope="col"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let worker of workers" [class.table-success]="!worker.worker_id && worker.errors.length==0">
                          <td>
                            <h4>
                                <span class="badge bg-secondary" *ngIf="worker.worker_id && !worker.restore"><i class="fa-solid fa-check"></i> {{ t('Already Imported') }}</span>
                                <span class="badge bg-warning" *ngIf="worker.restore"><i class="fa-solid fa-right-to-bracket"></i> {{ t('Restore Deleted Worker') }}</span>
                                <span class="badge bg-primary" *ngIf="!worker.worker_id && worker.errors.length==0"><i class="fa-solid fa-file-import"></i> {{ t('Ready to Import') }}</span>
                                <span class="badge bg-danger" *ngIf="!worker.worker_id && worker.errors.length!=0"><i class="fa-solid fa-circle-xmark"></i> {{ t('Data Error') }}</span>
                            </h4>
                          </td>
                          <td>
                            <span><b>{{worker.name}}</b></span>
                          </td>
                          <td>
                            {{worker.email}}
                          </td>
                          <td>
                              {{worker.phone}}
                          </td>
                          <td>
                              {{worker.group}}
                          </td>
                          <td *ngIf="worker.monitor_names">
                              {{worker.monitor_names}}
                          </td>
                          <td *ngIf="worker.extra_field_1">
                              {{worker.extra_field_1}}
                          </td>
                          <td *ngIf="worker.extra_field_2">
                              {{worker.extra_field_2}}
                          </td>
                          <td *ngIf="worker.extra_field_3">
                              {{worker.extra_field_3}}
                          </td>
                          <td *ngIf="worker.extra_field_4">
                              {{worker.extra_field_4}}
                          </td>
                          <td *ngIf="worker.extra_field_5">
                              {{worker.extra_field_5}}
                          </td>
                          <td>
                              <ul *ngIf="worker.errors.length > 0" class="text-danger">
                                  <li *ngFor="let error of worker.errors">{{error}}</li>
                              </ul>
                          </td>
                          <td>

                        </tr>
                      </tbody>

                  </table>

                </c-col>
              </c-row>
        </div>
    </div>


    <div class="row" *ngIf="step == 3">
        <div class="col-md-12">

            <p>{{ t('The following workers have now been imported or updated:') }}</p>

            <button type="button" class="btn btn-info  mb-2 text-white text-center" (click)="sendWelcome()">
              <i class="fa-solid fa-paper-plane"></i> {{ t('Send App Links to Workers') }}
              <div *ngIf="welcome_loading">
                <i class="fa-solid fa-spinner fa-lg fa-spin"></i>
              </div>
            </button>

            <c-row>
                <c-col>

                  <table
                  [hover]="true"
                  [responsive]="true"
                  [striped]="true"
                  align="middle"
                  cTable
                  class="mb-0 border"
                  >
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ t('Pin') }}</th>
                        <th scope="col">{{ t('Worker') }}</th>
                        <th scope="col">{{ t('Email') }}</th>
                        <th scope="col">{{ t('Cell/Phone') }}</th>
                        <th scope="col">{{ t('Group') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let worker of workers2">
                          <td>
                            <h4>
                                <span class="badge bg-success"><i class="fa-solid fa-check"></i> {{ t('Imported') }}</span>
                            </h4>
                          </td>
                          <td>
                              <span class="badge bg-secondary">{{ u.formatWorkerPin(worker.pin) }}</span>
                          </td>
                          <td>
                            <span><b>{{worker.name}}</b></span>
                          </td>
                          <td>
                            {{worker.email}}
                          </td>
                          <td>
                              {{worker.phone}}
                          </td>
                          <td>
                            <span *ngFor="let group of worker.group_names">
                                {{group}}
                              </span>
                          </td>
                          <td>

                        </tr>
                      </tbody>

                  </table>

                </c-col>
              </c-row>
        </div>
    </div>

</div>


</c-card-body>
</c-card>
